import { apiService } from '@api';

const STORE_NAME = 'priceRulesets';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        list: [],
        totalCount: 0,
        loading: false,
        selectedPriceRuleset: null,
        params: {},
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTotalCount(state, totalCount) {
            state.totalCount = totalCount;
        },
        setList(state, list) {
            state.list = list;
        },
        setSelectedPriceRuleset(state, selected) {
            state.selectedPriceRuleset = selected;
        },
        setParams(state, params) {
            state.params = params;
        },
    },
    getters: {
        allPriceRulesetsLoaded: (state) => state.list.length >= state.totalCount,
        list: (state) => state.list,
        selected: (state) => state.selectedPriceRuleset,
        loading: (state) => state.loading,
    },
    actions: {
        getPriceRulesets: async ({ commit, state }, props = { limit: 100, offset: 0 }) => {
            commit('setLoading', true);

            const response = await apiService.priceRulesets.get({ ...state.params, ...props });

            if (response.success) {
                const { list, totalCount } = response.data;
                totalCount && commit('setTotalCount', totalCount);
                commit(
                    'setList',
                    list.map((item) => ({
                        text: `${item.id} - ${item.name}`,
                        value: item.id,
                    }))
                );
                commit('setLoading', false);
                return list;
            }

            commit('setLoading', false);
        },
        getBySearch: async ({ commit }, props = { limit: 100, offset: 0, keyword: '' }) => {
            commit('setLoading', true);

            const response = await apiService.priceRulesets.get(props);

            if (response.success) {
                const { list, totalCount } = response.data;
                totalCount && commit('setTotalCount', totalCount);
                commit(
                    'setList',
                    list.map((item) => ({
                        text: `${item.id} - ${item.name}`,
                        value: item.id,
                    }))
                );
                commit('setLoading', false);
                return list;
            }

            commit('setLoading', false);
        },
        handleChange: ({ commit }, selected) => {
            commit('setSelectedPriceRuleset', selected);
        },
        resetState({ commit }) {
            commit('setList', []);
            commit('setTotalCount', 0);
            commit('setLoading', false);
            commit('setSelectedPriceRuleset', null);
        },
        setParams({ commit }, params) {
            commit('setParams', params);
        },
    },
};
